import React from 'react';
import { Controller } from 'react-hook-form';
import moment from 'moment-timezone';
import { FormControl } from '@material-ui/core';
import useReactHookFormStyles from '../../../../custom-components/form-components/ReactHookForm.styles';
import LocalizedDatePicker from '../../../../custom-widgets/LocalizedDatePicker';

export const convertMinutesToTime = (minutes) => {
    // eslint-disable-next-line eqeqeq
    if (minutes == undefined) return null;
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return moment().startOf('day').hours(hours).minutes(mins);
};

export const convertTimeToMinutes = (time) => {
    if (!time) return null;
    return time.hours() * 60 + time.minutes();
};

const DateFieldInput = ({ name, Picker, control, ...rest }) => {
    const classes = useReactHookFormStyles();

    return (
        <FormControl className={classes.formController}>
            <Controller
                name={name}
                control={control}
                render={({ field: { onChange, value, ...controllerField } }) => (
                    <LocalizedDatePicker
                        Picker={Picker}
                        onChange={(date) => onChange(convertTimeToMinutes(date))}
                        value={convertMinutesToTime(value)}
                        InputLabelProps={{ shrink: true }}
                        {...controllerField}
                        {...rest}
                        // wrap
                    />
                )}
            />
        </FormControl>
    );
};

export default DateFieldInput;
